<template>
  <div v-if="entries.length > 1 || (filterType == 'dash' && entries.length > 0) || filterType == 'price'"
    class="filter-option" :id=name.toLocaleLowerCase()>
    <div v-if="filterType == 'default' || filterType == 'search'" class="accordion">
      <div :class="['accordion-header', 'accordion-header-' + filterLabel.toLocaleLowerCase()]">
        <div class="accordion-header-top" @click="toggleAccordion">
          <div class="accordion-title">{{ filterLabel }}</div>
          <AccordionArrowIcon :class="{ rotated: isOpen }"></AccordionArrowIcon>
        </div>
        <div v-if="filterType == 'search' && isOpen" class="search-bar">
          <NInput v-model:value="searchQuery" placeholder="Search for your favorite brand" @input="onSearch"
            :theme-overrides="inputThemeOverrides" class="search-input">
            <template #prefix>
              <NIcon>
                <SearchIcon />
              </NIcon>
            </template>
          </NInput>
        </div>
      </div>
      <div class="accordion-content-container"
        :class="{ 'hidden': !isOpen, 'lens-treatment': name === 'LENS_TREATMENT_FACET_GL_US' }">
        <div v-if="(filterType == 'search' && isOpen)" class="top-brand-container">
          <Transition name="accordion" v-for="(singleFilter, index) in filteredEntries.filteredMostClicked">
            <Bean v-if="isOpen" :singleFilter="singleFilter" />
          </Transition>
        </div>
        <Transition v-if="(filterType == 'search')" name="accordion"
          v-for="(singleFilter, index) in filteredEntries.filteredOtherBrands">
          <Bean v-if="isOpen" :singleFilter="singleFilter" />
        </Transition>
        <Transition v-else name="accordion" v-for="(singleFilter, index) in entries">
          <Bean v-if="isOpen" :singleFilter="singleFilter" />
        </Transition>
      </div>
    </div>
    <div v-if="filterType == 'dash'" class="toggle-header" v-for="(singleFilter, index) in entries">
      <div :id="'toggle-label-' + filterLabel.toLocaleLowerCase().replaceAll(' ', '-')" class="toggle-label">
        <div :class="['accordion-title', { 'accordion-disabled': singleFilter.disabled }]">{{ filterLabel }}</div>
      </div>
      <NSwitch v-model:value="isActive" @update:value="handleSwitchChange(singleFilter)"
        :disabled="singleFilter.disabled" :theme-overrides="switchThemeOverrides"
        :aria-labelledby="'toggle-label-' + filterLabel.toLocaleLowerCase().replaceAll(' ', '-')"
        class="toggle-switch" />
      <div v-if="name == 'HIGH_PRESCRIPTION'"
        :class="['dash-filter-description', { 'dash-filter-description-disabled': singleFilter.disabled }]">
        Range: above +3.6 or below -3.6
      </div>
      <div v-if="name == 'POLARIZED'"
        :class="['dash-filter-description', { 'dash-filter-description-disabled': singleFilter.disabled }]">
        {{ singleFilter.extendedData.field2 }}
      </div>
    </div>
    <div v-if="filterType == 'price'" class="accordion">
      <div :class="['accordion-header', 'accordion-header-price']">
        <div class="accordion-header-top" @click="toggleAccordion">
          <div class="accordion-title">{{ filterLabel }} </div>
          <AccordionArrowIcon :class="{ rotated: isOpen }"></AccordionArrowIcon>
        </div>
        <div v-if="isOpen" class="accordion-content-container">
          <div class="price-filter">
            <div class="price-range">
              <div class="price-labels">
                <span>${{ priceRange[0] }} - ${{ priceRange[1] }} <span v-if="priceRange[1] == maxPriceFilter"> and more
                  </span>
                </span>
              </div>
              <NSlider v-model:value="priceRange" :min="minPriceFilter" :max="maxPriceFilter" :step="1" :range="true"
                @update:value="onSliderChange" class="n-slider" />
            </div>
            <div class="preset-filters" v-for="(singleFilter, index) in entries">
              <div :class="['single-filter-value', { 'selected': isSelectedPrice(singleFilter) }]"
                @click="setPresetPrice(singleFilter)">{{ singleFilter.label }}
                <div v-if="isSelectedPrice(singleFilter)" class="delete-filter-icon-price">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_774_9337)">
                      <path
                        d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM8 14.6667C4.324 14.6667 1.33333 11.676 1.33333 8C1.33333 4.324 4.324 1.33333 8 1.33333C11.676 1.33333 14.6667 4.324 14.6667 8C14.6667 11.676 11.676 14.6667 8 14.6667Z"
                        fill="white" />
                      <path
                        d="M10.1953 4.862L8 7.05733L5.80467 4.862L4.862 5.80467L7.05733 8L4.862 10.1953L5.80467 11.138L8 8.94267L10.1953 11.138L11.138 10.1953L8.94267 8L11.138 5.80467L10.1953 4.862Z"
                        fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_774_9337">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { entries } from "lodash";
import FilterOption from "./FilterOption.ts";
export default {
  ...FilterOption,
};
</script>
<style lang="scss">
@import "./FilterOption.scss";
</style>